var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.symbol === '$')?[_vm._v("\n        "+_vm._s(_vm.symbol)+_vm._s(_vm.formattedPrice)+"\n    ")]:[_vm._v("\n        "+_vm._s(_vm.formattedPrice)+" "+_vm._s(_vm.symbol)+"\n    ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }